module.exports = __webpack_public_path__ + "static/5-regular-security-updates-c620e87a73cdf170f839bb56fa6820f4.png";